import { identify, Identify } from '@amplitude/marketing-analytics-browser'
import { initAmplitude, trackAmplitudeEvent, setUserPropertiesFromQuery } from './amplitude'
import config from './amplitude/config.json'
import { userAgentParse } from '../common/user-agent'

const indicators = {
  isHome: 'isViewHome',
  isWorksheets: 'isViewWorksheets',
  isBlog: 'isViewBlog',
  isCategory: 'isViewCategory',
  isTemplate: 'isViewTemplate',
  isLand: 'isViewLand',
  isPageSeo: 'isViewPageSeo'
}

window.addEventListener('DOMContentLoaded', () => {
  const promise = new Promise(resolve => {
    initAmplitude()
    resolve()
  })

  promise
    .then(() => {
      const identifyObj = new Identify()

      const userParameters = userAgentParse()
      const screen = userParameters.screen
      const mobile = userParameters.mobile
      const os = userParameters.os
      const osVersion = userParameters.osVersion
      const cookies = userParameters.cookies

      identifyObj.set('Screen size', screen)
      identifyObj.set('Mobile', mobile)
      identifyObj.set('OS', os)
      identifyObj.set('OS version', osVersion)
      identifyObj.set('Cookie enabled', cookies)

      identify(identifyObj)

      return true
    })
    .then(() => {
      setUserPropertiesFromQuery()
      return true
    })
    .then(() => {
      const inputPageIndicator = document.querySelector('#page-indicator')
      if (inputPageIndicator) {
        const postTitle = document.querySelector('#post-title').value
        const categoryTitle = document.querySelector('#category-title').value
        const value = inputPageIndicator.value
        const isHome = (value === indicators.isHome)
        const isTemplate = (value === indicators.isTemplate)
        const isPageSeo = (value === indicators.isPageSeo)
        const isLand = (value === indicators.isLand)
        /**
                 * If this is a fake page, we are not in a hurry with the Page view event
                 * push event with parameters and
                 * push in which split category the user is
                 */
        if (isHome) {
          trackAmplitudeEvent(config.events.pageViewHome)
        } else if (isPageSeo) {
          trackAmplitudeEvent(config.events.pageViewSeo, {
            category: categoryTitle,
            articel_name: postTitle
          })
        } else if (isLand) {
          trackAmplitudeEvent(config.events.pageViewLand, {
            land_name: postTitle
          })
        }
      }
    })
})
